import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { NavService } from './../navigation/navigation.service';
import { CVFormService } from './../coverage-form.service';

import {
  PaxFormControlService,
  BackendService,
  BobtailStore,
  SAVE_FORM_STEP,
  UPDATE_STORE
} from './../../shared/index';
import { FormReviewCoverageService } from './form-review-coverage.service';

declare var fbq;

@Component({
  selector: 'pax-cf-form-review-coverage',
  template: require('./form-review-coverage.component.html'),
  providers: [
    PaxFormControlService,
    FormReviewCoverageService
  ]
})
export class FormReviewCoverageComponent implements OnInit, OnDestroy {
  formReviewCoverage: FormGroup;
  questions: any[];
  questionAgree1: any;
  questionAgree2: any;
  questionAgree3: any;
  questionSignature: any;
  questionDate: any;
  payload: Object = {};
  preliminary: Object = {};
  storeData;
  routeData;
  formSubmitted = false;

  constructor(
    private _store: Store<any>,
    private _backend: BackendService,
    private FormControlService: PaxFormControlService,
    private dataService: FormReviewCoverageService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _cv: CVFormService,
    private _ns: NavService
  ) {}

  ngOnInit() {
    // resolve router data
    this.routeData = this._route.data.subscribe((data) => {
      this._store.dispatch({ type: UPDATE_STORE, payload: { steps: data['forms'][1], settings: data['forms'][0] } });
    });

    // get fields array from the service
    this.questions = this.dataService.getQuestions();
    this.questionAgree1 = this.dataService.getAgree1();
    this.questionAgree2 = this.dataService.getAgree2();
    this.questionAgree3 = this.dataService.getAgree3();
    this.questionSignature = this.dataService.getSignature();
    this.questionDate = this.dataService.getSignatureDate();

    // init form fields
    this.formReviewCoverage = this.FormControlService.toFormGroup(this.questions);
    this.formReviewCoverage.addControl('agreeCheckBox1', this.FormControlService.toFormControl(this.questionAgree1));
    this.formReviewCoverage.addControl('agreeCheckBox2', this.FormControlService.toFormControl(this.questionAgree2));
    this.formReviewCoverage.addControl('agreeCheckBox3', this.FormControlService.toFormControl(this.questionAgree3));
    this.formReviewCoverage.addControl('signature', this.FormControlService.toFormControl(this.questionSignature));
    this.formReviewCoverage.addControl('signatureDate', this.FormControlService.toFormControl(this.questionDate));

    // get data from store and prefill the form
    this.storeData = this._store.select('cvform').subscribe((store: BobtailStore) => {
      this.payload = store.steps['review-coverage'];
      this.preliminary = store.steps['preliminary'];
    });

    this.formReviewCoverage.controls['additionalTowingAndStorage'].valueChanges.subscribe(addTowingAndStorage => {
      this._cv.sendToServerAndUpdateStore('preliminary', Object.assign({}, this.preliminary, {
        towingAndStorage: addTowingAndStorage ? 20 : 0
      })).then(data => this._store.dispatch({ type: SAVE_FORM_STEP, payload: data }));
    });

    this.formReviewCoverage.patchValue(this.payload || {});
  }

  ngOnDestroy() {
    this.storeData.unsubscribe();
    this.routeData.unsubscribe();
  }

  onSubmit() {
    this.formSubmitted = true;

    // if (this._cv.appEnv === 'live') {
    //   fbq('track', 'Lead', {});
    //   fbq('track', 'CompleteRegistration');
    // }

    this._cv.sendToServerAndUpdateStore('review-coverage', this.formReviewCoverage.value, true)
    .then(() => {
      this._ns.manualActiveStep('application-status');
      this._router.navigate(['']);
    })
    .catch(err => console.log(err));
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/form-review-coverage/form-review-coverage.component.ts